import React from 'react';

// Line drawings for "The QPS Standard" row on the public homepage.
//
// Same rules as the seal and the portal icons: hairline strokes, no fills,
// currentColor so a section can tint the whole row at once. Inline SVG rather
// than an icon package — the brand rules out emojis, and this is four shapes.

const Svg = ({ size = 34, children }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" fill="none"
    stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true" style={{ flexShrink: 0 }}>
    {children}
  </svg>
);

// Professional appearance — a work shirt.
const IconUniform = (p) => (
  <Svg {...p}>
    <path d="M12 5 6 8v5h3v14h14V13h3V8l-6-3" />
    <path d="M12 5c0 2.2 1.8 4 4 4s4-1.8 4-4" />
  </Svg>
);

// Clear communication — a speech bubble, mid-sentence.
const IconMessage = (p) => (
  <Svg {...p}>
    <path d="M27 17c0 4.4-4.9 8-11 8-1.2 0-2.4-.14-3.5-.4L6 27l1.7-4.3C6 21.2 5 19.2 5 17c0-4.4 4.9-8 11-8s11 3.6 11 8Z" />
    <path d="M11.5 17h.01M16 17h.01M20.5 17h.01" strokeWidth="2" />
  </Svg>
);

// Respect for your home — a house under a roof line, drawn like the seal's.
const IconHouse = (p) => (
  <Svg {...p}>
    <path d="M4 15.5 16 5.5l12 10" />
    <path d="M7 14v13h18V14" />
    <path d="M13 27v-7h6v7" />
  </Svg>
);

// Quality workmanship — a claw hammer.
const IconHammer = (p) => (
  <Svg {...p}>
    <path d="M9.5 10.5 6 7c1.9-1.9 4.6-2.4 6.6-1.3l3 1.7 4.2-2.4 4.7 4.7-2.4 4.2 1.7 3c1.1 2 .6 4.7-1.3 6.6l-3.5-3.5" />
    <path d="m18.8 20 -8.4 8.4a2.3 2.3 0 0 1-3.3 0l-1.5-1.5a2.3 2.3 0 0 1 0-3.3L14 15.2" />
  </Svg>
);

// The trust line under the banner CTA.
export const IconShield = (p) => (
  <Svg {...p}>
    <path d="M16 4 6 8v8.5c0 5.8 4.1 10.4 10 11.5 5.9-1.1 10-5.7 10-11.5V8L16 4Z" />
    <path d="m11.5 16 3.2 3.2L21 12.5" />
  </Svg>
);

// brandConfig names an icon by string, so the page never imports one directly.
const ICONS = { uniform: IconUniform, message: IconMessage, house: IconHouse, hammer: IconHammer };

export default function StandardIcon({ name, size = 34 }) {
  const Icon = ICONS[name] || IconHouse;
  return <Icon size={size} />;
}
